<template>
  <div class="w1200 dealer-page">
    <!-- 顶部标题栏：参考 suoshuidan_dating 风格 -->
    <div class="dealer-header">
      <span class="dealer-title">软件交易师：{{ dealerName || '未知' }}</span>
    </div>

    <!-- 板块一：个人信息 -->
    <div class="section">
      <div class="section-title">一、个人信息</div>
      <div class="info-card">
        <el-avatar class="info-avatar" :size="88" :src="dealerInfo.avatar || defaultAvatar">
          {{ dealerName ? dealerName.charAt(0) : '?' }}
        </el-avatar>
        <div class="info-main">
          <div class="info-name">
            {{ dealerInfo.name || dealerName || '未知' }}
            <span v-if="dealerInfo.isTrader" class="info-level">认证软件交易师</span>
          </div>
          <div class="info-sub">账号：{{ dealerInfo.userName || '—' }}</div>
          <div class="info-meta">
            <span>入驻时间：<span class="info-num" style="color:#409EFF">{{ dealerInfo.joinTime || '—' }}</span></span>
            <span>拥有软件：<span class="info-num" style="color:#67C23A">{{ dealerInfo.ownedTotal }} 款</span></span>
            <span>审核通过：<span class="info-num" style="color:#E6A23C">{{ dealerInfo.auditApprovedCount }} 款</span></span>
            <span>审核未通过：<span class="info-num" style="color:#F56C6C">{{ dealerInfo.auditRejectedCount }} 款</span></span>
            <span>免费软件：<span class="info-num" style="color:#13C2C2">{{ dealerInfo.freeCount }} 款</span></span>
            <span>付费软件：<span class="info-num" style="color:#9C27B0">{{ dealerInfo.paidCount }} 款</span></span>
            <span>总点击量：<span class="info-num" style="color:#EB2F96">{{ dealerInfo.totalHits }} 次</span></span>
            <span>在售转让：<span class="info-num" style="color:#FA8C16">{{ dealerInfo.transferOnSaleCount }} 款</span></span>
          </div>
        </div>
      </div>
    </div>

    <!-- 板块二：身份标签（来自 roles 字段） -->
    <div class="section">
      <div class="section-title">二、身份标签</div>
      <div class="identity-card">
        <span v-for="(item, i) in identities" :key="i" class="identity-tag" :style="identityStyle(i)">
          {{ item.name }}<template v-if="item.statusIntro"> · {{ item.statusIntro }}</template>
        </span>
        <span v-if="!identities.length" class="empty-tip">暂无身份标签</span>
      </div>
    </div>

    <!-- 板块三：发布的软件（免费 / 付费 / 转让，可点击购买） -->
    <div class="section">
      <div class="section-title">三、发布的软件</div>
      <div class="type">
        <span v-for="(item, index) in type.arr" :key="index"
          :class="type.active === index ? 'active' : ''"
          @click="toggleType(index)">{{ item.label }}</span>
      </div>

      <!-- 定制软件厅下的二级切换：众筹 / 个人定制 -->
      <div class="crowd-filter" v-if="type.active === 2">
        <span class="crowd-filter-label">定制类型：</span>
        <span v-for="opt in crowdModeArr" :key="opt.value"
          :class="['crowd-filter-item', crowdMode === opt.value ? 'active' : '']"
          @click="changeCrowdMode(opt.value)">{{ opt.label }}</span>
      </div>

      <div class="table" v-loading="loading" element-loading-text="加载中...">
        <!-- 免费厅 -->
        <el-table v-if="type.active == 0" :data="tableData" border style="width: 100%"
          :cell-style="{ 'text-align': 'center' }"
          :header-cell-style="{ background: '#DBDBDB', color: '#000', 'text-align': 'center' }">
          <el-table-column prop="softName" :show-overflow-tooltip="true" label="软件名称" />
          <el-table-column prop="intro" :show-overflow-tooltip="true" label="软件简介" />
          <el-table-column prop="hits" :show-overflow-tooltip="true" label="点击量" width="70" />
          <el-table-column :show-overflow-tooltip="true" label="发布者是否杀毒处理" width="160">
            <template slot-scope="scope">
              <span :class="scope.row.noVirus == 1 ? 'tag-yes' : 'tag-no'">{{ scope.row.noVirus == 1 ? '是' : '否' }}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="软件来源">
            <template slot-scope="scope">
              <span class="src-tag" :style="sourceStyle(scope.row.softwareSourceIntro)">{{ scope.row.softwareSourceIntro }}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="请平台技术再杀毒">
            <template slot-scope="scope">
              <span v-if="scope.row.coin" class="kill-virus-btn" @click="killVirusAgain(scope.row)">再杀毒<span class="kill-coin">{{ scope.row.coin }}</span>缩币</span>
              <span v-else>—</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="发布时间" width="140">
            <template slot-scope="scope">
              <span class="time-sm">{{ scope.row.updateTime }}</span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 有偿转让厅 -->
        <el-table v-if="type.active == 1" :data="tableData" border style="width: 100%"
          :cell-style="{ 'text-align': 'center' }"
          :header-cell-style="{ background: '#DBDBDB', color: '#000', 'text-align': 'center' }">
          <el-table-column prop="softName" :show-overflow-tooltip="true" label="软件名称" />
          <el-table-column prop="intro" :show-overflow-tooltip="true" label="软件简介" />
          <el-table-column prop="hits" :show-overflow-tooltip="true" label="点击量" width="70" />
          <el-table-column :show-overflow-tooltip="true" label="是否做过杀毒处理">
            <template slot-scope="scope">
              <span :class="scope.row.noVirus == 1 ? 'tag-yes' : 'tag-no'">{{ scope.row.noVirus == 1 ? '是' : '否' }}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="软件来源">
            <template slot-scope="scope">
              <span class="src-tag" :style="sourceStyle(scope.row.softwareSourceIntro)">{{ scope.row.softwareSourceIntro }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" :show-overflow-tooltip="true" label="免费维护期" />
          <el-table-column :show-overflow-tooltip="true" label="发布时间" width="140">
            <template slot-scope="scope">
              <span class="time-sm">{{ scope.row.updateTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="mini" style="color:#E6A23C;padding-left:0" @click="openBuy(scope.row)">购买</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 定制软件厅 - 个人定制（crowdMode=personal，接口 software/custom/manage/list） -->
        <el-table v-if="type.active == 2 && crowdMode === 'personal'" :data="tableData" border style="width: 100%"
          :cell-style="{ 'text-align': 'center' }"
          :header-cell-style="{ background: '#DBDBDB', color: '#000', 'text-align': 'center' }">
          <el-table-column prop="title" :show-overflow-tooltip="true" label="定制软件标题" min-width="160" />
          <el-table-column prop="demand" :show-overflow-tooltip="true" label="需求详细说明" min-width="200" />
          <el-table-column label="预算金额" width="120">
            <template slot-scope="scope">
              <span style="color:#e6a23c">{{ scope.row.budget != null ? scope.row.budget + ' 元' : '—' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="budgetRemark" :show-overflow-tooltip="true" label="预算补充说明" min-width="160" />
          <el-table-column label="附件" min-width="120">
            <template slot-scope="scope">
              <span v-if="!formatFiles(scope.row.demandFile).length" class="file-empty">—</span>
              <a v-for="(f, i) in formatFiles(scope.row.demandFile)" :key="i" class="file-link"
                @click="downloadFile(f)">{{ fileName(f) }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" :show-overflow-tooltip="true" label="创建时间" min-width="160" />
          <el-table-column label="我的投标状态" width="110">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.myBidStatusDesc" size="mini">{{ scope.row.myBidStatusDesc }}</el-tag>
              <span v-else class="file-empty">—</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="140" fixed="right">
            <template slot-scope="scope">
              <el-button v-if="!isOwnRow(scope.row) && (scope.row.myBidStatus == null || scope.row.myBidStatus === 3)" type="text" size="mini" style="color:#409EFF" @click="openBid(scope.row)">投标</el-button>
              <el-button v-if="!isOwnRow(scope.row) && scope.row.myBidStatus === 0" type="text" size="mini" style="color:#E6A23C" @click="withdrawBid(scope.row)">撤标</el-button>
              <el-button type="text" size="mini" style="color:#67C23A" @click="openDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 定制软件厅 - 众筹（crowdMode=crowdfunding，接口 software/custom/manage/list） -->
        <el-table v-if="type.active == 2 && crowdMode === 'crowdfunding'" :data="tableData" border style="width: 100%"
          :cell-style="{ 'text-align': 'center' }"
          :header-cell-style="{ background: '#DBDBDB', color: '#000', 'text-align': 'center' }">
          <el-table-column prop="title" :show-overflow-tooltip="true" label="众筹软件标题" min-width="160" />
          <el-table-column label="几人众筹" width="100">
            <template slot-scope="scope">
              <span class="crowd-num">{{ scope.row.crowdNumber != null && scope.row.crowdNumber !== '' ? scope.row.crowdNumber + ' 人' : '—' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="demand" :show-overflow-tooltip="true" label="需求详细说明" min-width="200" />
          <el-table-column label="预算金额" width="120">
            <template slot-scope="scope">
              <span style="color:#e6a23c">{{ scope.row.budget != null ? scope.row.budget + ' 元' : '—' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="budgetRemark" :show-overflow-tooltip="true" label="预算补充说明" min-width="160" />
          <el-table-column label="附件" min-width="120">
            <template slot-scope="scope">
              <span v-if="!formatFiles(scope.row.demandFile).length" class="file-empty">—</span>
              <a v-for="(f, i) in formatFiles(scope.row.demandFile)" :key="i" class="file-link"
                @click="downloadFile(f)">{{ fileName(f) }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" :show-overflow-tooltip="true" label="创建时间" width="160" />
          <el-table-column label="操作" width="220" fixed="right">
            <template slot-scope="scope">
              <el-button v-if="!isOwnRow(scope.row)" type="text" size="mini" style="color:#E6A23C" @click="openBid(scope.row)">众筹</el-button>
              <el-button type="text" size="mini" style="color:#67C23A" @click="openDetail(scope.row)">详情</el-button>
              <el-button type="text" size="mini" style="color:#909399" @click="openMessage(scope.row)">留言</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination v-if="listPagin.total > 0" style="padding-top:20px;text-align:right" background
          layout="total, sizes, prev, pager, next" @current-change="changePage" @size-change="changePageSize"
          :page-size="listPagin.limit" :current-page="listPagin.page" :page-sizes="[10, 15, 20, 50]"
          :total="listPagin.total">
        </el-pagination>
      </div>
    </div>

    <!-- 有偿转让软件购买（下单）弹窗 -->
    <el-dialog title="购买软件" :visible.sync="buyVisible" width="420px" append-to-body>
      <div v-if="buyRow" class="buy-box">
        <div class="buy-name">软件：{{ buyRow.softName }}</div>
        <div class="buy-row">
          <span class="buy-label">支付方式：</span>
          <el-radio-group v-model="buyPayType">
            <el-radio label="balancepay">余额支付</el-radio>
            <el-radio label="wxpay">微信支付</el-radio>
            <el-radio label="alipay">支付宝支付</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="buyVisible = false">取消</el-button>
        <el-button type="primary" :loading="buyLoading" @click="confirmBuy">确认下单</el-button>
      </div>
    </el-dialog>

    <!-- 定制软件需求详情弹窗（个人定制 / 众筹通用） -->
    <el-dialog :title="detailMode === 'crowdfunding' ? '众筹需求详情' : '定制需求详情'" :visible.sync="detailVisible" width="720px" append-to-body>
      <div v-if="detailRow" class="detail-box">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="标题">{{ detailRow.title || '—' }}</el-descriptions-item>
          <el-descriptions-item label="定制模式">
            <el-tag size="small" :type="detailRow.mode === 'crowdfunding' ? 'warning' : 'info'">{{ modeText(detailRow.mode) }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item v-if="detailRow.mode === 'crowdfunding'" label="几人众筹">
            {{ detailRow.crowdNumber != null && detailRow.crowdNumber !== '' ? detailRow.crowdNumber + ' 人' : '—' }}
          </el-descriptions-item>
          <el-descriptions-item label="预算金额">{{ detailRow.budget != null ? detailRow.budget + ' 元' : '—' }}</el-descriptions-item>
          <el-descriptions-item label="预算补充说明" :span="2">{{ detailRow.budgetRemark || '—' }}</el-descriptions-item>
          <el-descriptions-item label="需求详细说明" :span="2">{{ detailRow.demand || '—' }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ detailRow.createTime || '—' }}</el-descriptions-item>
          <el-descriptions-item label="附件">
            <span v-if="!formatFiles(detailRow.demandFile).length" class="file-empty">—</span>
            <a v-for="(f, i) in formatFiles(detailRow.demandFile)" :key="i" class="file-link" @click="downloadFile(f)">{{ fileName(f) }}</a>
          </el-descriptions-item>
        </el-descriptions>

        <!-- 众筹：参与人列表 -->
        <template v-if="detailRow.mode === 'crowdfunding'">
          <div class="detail-sub-title">参与众筹列表</div>
          <el-table :data="crowdListOf(detailRow)" border size="small" style="width:100%"
            :cell-style="{ 'text-align': 'center' }"
            :header-cell-style="{ background: '#f5f7fa', color: '#333', 'text-align': 'center' }">
            <el-table-column type="index" label="#" width="50" />
            <el-table-column prop="participantName" :show-overflow-tooltip="true" label="参与人/团队" min-width="140" />
            <el-table-column prop="amount" :show-overflow-tooltip="true" label="众筹金额" width="120">
              <template slot-scope="scope">{{ scope.row.amount != null ? scope.row.amount + ' 元' : '—' }}</template>
            </el-table-column>
            <el-table-column prop="statusIntro" :show-overflow-tooltip="true" label="状态" width="100" />
            <el-table-column prop="joinTime" :show-overflow-tooltip="true" label="参与时间" width="160" />
          </el-table>
          <div v-if="!crowdListOf(detailRow).length" class="detail-empty">暂无参与众筹记录</div>
        </template>
      </div>
      <div slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 投标 / 众筹 填写弹窗 -->
    <el-dialog :title="bidMode === 'crowdfunding' ? '参与众筹' : '投标'" :visible.sync="bidVisible" width="520px" append-to-body>
      <el-form :model="bidForm" label-width="110px" v-if="bidRow">
        <el-form-item label="需求标题">
          <span>{{ bidRow.title }}</span>
        </el-form-item>

        <!-- 公共：金额 -->
        <el-form-item :label="bidMode === 'crowdfunding' ? '众筹金额(元)' : '投标金额(元)'" required>
          <el-input v-model="bidForm.amount" placeholder="请输入金额" type="number" />
        </el-form-item>

        <!-- 个人定制：预计开发周期 -->
        <el-form-item v-if="bidMode === 'personal'" label="预计开发周期" required>
          <el-input v-model="bidForm.duration" placeholder="请输入预计开发周期（天）" type="number">
            <template slot="append">天</template>
          </el-input>
        </el-form-item>

        <!-- 团队名称：个人定制与众筹均为必需 -->
        <el-form-item :label="bidMode === 'crowdfunding' ? '参与团队' : '投标团队'" required>
          <el-input v-model="bidForm.team" placeholder="请输入团队/个人名称" />
        </el-form-item>

        <!-- 个人定制：手机号（联系电话，必填） -->
        <el-form-item v-if="bidMode === 'personal'" label="手机号" required>
          <el-input v-model="bidForm.contactPhone" placeholder="请输入手机号" />
        </el-form-item>

        <!-- 众筹：联系电话（必需） -->
        <el-form-item v-if="bidMode === 'crowdfunding'" label="联系电话" required>
          <el-input v-model="bidForm.phone" placeholder="请输入联系电话" />
        </el-form-item>

        <!-- 个人定制：解决方案说明（必需） -->
        <el-form-item v-if="bidMode === 'personal'" label="解决方案说明" required>
          <el-input v-model="bidForm.solution" type="textarea" :rows="3" placeholder="请填写解决方案说明" />
        </el-form-item>

        <!-- 个人定制：团队自荐说明（可选） -->
        <el-form-item v-if="bidMode === 'personal'" label="团队自荐说明">
          <el-input v-model="bidForm.selfRecommendation" type="textarea" :rows="2" placeholder="请填写团队自荐说明（选填）" />
        </el-form-item>

        <!-- 众筹：认购备注（可选） -->
        <el-form-item v-if="bidMode === 'crowdfunding'" label="认购备注">
          <el-input v-model="bidForm.remark" type="textarea" :rows="3" placeholder="补充说明（选填）" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="bidVisible = false">取消</el-button>
        <el-button type="primary" :loading="bidLoading" @click="submitBid">提交</el-button>
      </div>
    </el-dialog>

    <!-- 众筹留言板块（沟通记录） -->
    <el-dialog title="沟通记录" :visible.sync="msgVisible" width="560px" append-to-body>
      <div v-if="msgRow" class="msg-box">
        <div class="msg-row">需求标题：{{ msgRow.title }}</div>
        <el-descriptions class="msg-demand" :column="1" border size="small">
          <el-descriptions-item label="需求详细说明">{{ msgRow.demand || '—' }}</el-descriptions-item>
          <el-descriptions-item label="预算金额">{{ msgRow.budget != null ? msgRow.budget + ' 元' : '—' }}</el-descriptions-item>
          <el-descriptions-item label="预算补充说明">{{ msgRow.budgetRemark || '—' }}</el-descriptions-item>
          <el-descriptions-item label="附件">
            <template v-if="formatFiles(msgRow.demandFile).length">
              <div v-for="(f, fi) in formatFiles(msgRow.demandFile)" :key="fi" class="file-line">
                <el-link type="primary" :underline="false" @click="downloadFile(f)">{{ fileName(f) || ('附件' + (fi + 1)) }}</el-link>
              </div>
            </template>
            <span v-else>—</span>
          </el-descriptions-item>
        </el-descriptions>
        <div class="msg-toolbar">
          <el-button size="mini" :loading="msgLoading" @click="loadMessages(msgRow)">刷新留言记录</el-button>
        </div>
        <div class="msg-list" v-loading="msgLoading">
          <div v-if="!msgList.length && !msgLoading" class="msg-empty">暂无沟通记录</div>
          <div v-for="(item, i) in msgList" :key="i" class="msg-item"
            :class="item.mine ? 'msg-item-mine' : ''">
            <div class="msg-item-head">
              <span class="msg-item-name">{{ messageName(item) }}</span>
              <span class="msg-item-time">{{ item.createTime || '' }}</span>
            </div>
            <div class="msg-item-content">{{ item.content }}</div>
          </div>
        </div>
        <div class="msg-input">
          <el-input v-model="msgContent" type="textarea" :rows="3" placeholder="请输入沟通内容" />
          <el-button type="primary" :loading="msgSending" @click="sendMessage">发送</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { softwareSourceList, softwarePaidTransferOrder, softwareTraderProfile, softwareCustomManageList, softwareCustomMessageList, softwareCustomMessageSend, softwareCustomCrowdJoin, softwareCustomBidSubmit, softwareCustomBidWithdraw } from '@/api/software'
import { softwareList } from '@/api/home'

export default {
  data() {
    return {
      dealerName: '',
      defaultAvatar: '',

      // 板块一：个人信息（来自 /stage-api/software/trader/profile/{userId}）
      dealerInfo: {
        name: '',
        avatar: '',
        userName: '',
        isTrader: false,
        joinTime: '',
        ownedTotal: 0,
        auditApprovedCount: 0,
        auditRejectedCount: 0,
        freeCount: 0,
        paidCount: 0,
        totalHits: 0,
        transferOnSaleCount: 0,
      },

      // 板块二：身份标签（来自接口 roles 字段）
      identities: [],

      // 板块三：发布的软件（来自主页面接口 software/software/list，按 classification 由后端过滤）
      type: {
        arr: [
          { label: '免费厅', value: 'FREE' },
          { label: '有偿转让厅', value: 'PAID_TRANSFER' },
          { label: '定制软件厅', value: 'CUSTOM' },
        ],
        active: 0,
      },
      // 是否有众筹标识：后端返回该交易师有众筹时才显示「定制软件厅」下的「众筹」二级（默认 false 不显示）
      hasCrowdTab: false,
      // 定制软件厅下的二级切换：''=个人定制 / crowdfunding=多人众筹（默认个人定制）
      crowdMode: 'personal',
      crowdModeArr: [
        { label: '个人定制', value: 'personal' },
        { label: '众筹', value: 'crowdfunding' },
      ],
      tableData: [],
      loading: false,
      listPagin: {
        page: 1,
        limit: 15,
        total: 0,
      },

      // 软件来源配色：label -> { bg, fg, bd }
      sourceColorMap: {},

      // 有偿转让软件购买（下单）
      buyVisible: false,
      buyRow: null,
      buyPayType: 'balancepay',
      buyLoading: false,

      // 定制软件需求详情弹窗
      detailVisible: false,
      detailRow: null,
      detailMode: '', // personal / crowdfunding
      // 投标 / 众筹 填写弹窗（暂不调接口）
      bidVisible: false,
      bidRow: null,
      bidMode: '', // personal / crowdfunding
      bidLoading: false,
      bidForm: {
        amount: '', // 金额：投标=报价 / 众筹=认购金额
        duration: '', // 个人定制：预计开发周期（天）
        team: '', // 团队/个人名称
        phone: '', // 众筹：联系电话
        solution: '', // 个人定制：解决方案说明
        selfRecommendation: '', // 个人定制：团队自荐说明
        remark: '', // 众筹：认购备注
        contactPhone: '', // 个人定制：手机号（联系电话）
      },

      // 众筹留言板块（沟通记录）
      msgVisible: false,
      msgRow: null,
      msgList: [],
      msgLoading: false,
      msgContent: '',
      msgSending: false,
    };
  },
  created() {
    this.dealerName = this.$route.query.dealer || ''
    this.getSoftwareSources()
    // 板块一/二：软件交易师全景详情（个人信息 + 身份标签），仍用 trader/profile 接口
    const userId = this.$route.query.userId
    if (userId !== undefined && userId !== null && userId !== '') {
      this.loadTraderProfile(userId)
    }
    // 板块三：发布的软件表格，走主页面软件列表接口（带 queryUserId）
    this.getList()
  },
  methods: {
    // ============ 软件交易师全景详情 ============
    loadTraderProfile(userId) {
      softwareTraderProfile(Number(userId)).then(res => {
        const data = res && (res.data !== undefined ? res.data : res)
        if (!data) return
        // 板块一：个人信息（直接取接口字段）
        this.dealerInfo = {
          name: data.nickName || data.userName || '',
          avatar: data.avatar || '',
          userName: data.userName || '',
          isTrader: !!data.isSoftwareTrader,
          joinTime: data.createTime || '',
          ownedTotal: data.ownedTotal || 0,
          auditApprovedCount: data.auditApprovedCount || 0,
          auditRejectedCount: data.auditRejectedCount || 0,
          freeCount: data.freeCount || 0,
          paidCount: data.paidCount || 0,
          totalHits: data.totalHits || 0,
          transferOnSaleCount: data.transferOnSaleCount || 0,
        }
        if (this.dealerInfo.name) this.dealerName = this.dealerInfo.name

        // 板块二：身份标签（来自 roles 字段）
        if (Array.isArray(data.roles)) {
          this.identities = data.roles
            .map(r => ({
              name: r.roleName || r.name || '',
              status: r.status,
              statusIntro: r.statusIntro || '',
            }))
            .filter(x => x.name)
        }

        // 板块三的软件表格改由主页面接口 software/software/list 提供（见 getList）

        // 是否有众筹标识：后端返回该交易师有众筹时才显示「众筹」tab
        this.hasCrowdTab = this.checkCrowdFlag(data)
      }).catch(err => {
        console.warn('软件交易师全景详情加载失败', err)
      })
    },

    // ============ 板块三：调用列表接口 ============
    // 免费厅/有偿转让厅：走主页面 software/software/list（classification 过滤）
    // 定制软件厅（active===2）：统一走 software/custom/manage/list，按二级切换（crowdMode）区分：
    //   personal=个人定制 / crowdfunding=众筹
    getList() {
      this.loading = true
      const userId = this.$route.query.userId
      // 定制软件厅：active === 2，按二级切换（个人定制 / 众筹）走 manage/list
      if (this.type.active === 2) {
        const userId = this.$route.query.userId
        const params = {
          mode: this.crowdMode, // personal=个人定制 / crowdfunding=众筹
          auditStatus: 1, // 审核通过
          pageNum: this.listPagin.page,
          pageSize: this.listPagin.limit,
        }
        // 定制软件厅两个二级（个人定制 / 众筹）都带 userId 参数（取路由上的交易师 userId）
        if (userId !== undefined && userId !== null && userId !== '') {
          params.userId = Number(userId)
        }
        softwareCustomManageList(params).then(res => {
          const payload = res && (res.data !== undefined ? res.data : res)
          const rows = (payload && payload.rows) || (Array.isArray(payload) ? payload : [])
          this.tableData = rows
          this.listPagin.total = (payload && payload.total) || 0
        }).catch(err => {
          console.warn('定制软件列表加载失败', err)
          this.tableData = []
        }).finally(() => {
          this.loading = false
        })
        return
      }
      softwareList({
        preType: '',                 // 不限定彩种：展示该交易师全部彩种软件
        softwareSource: '',          // 不限定来源
        classification: this.type.arr[this.type.active].value, // FREE / PAID_TRANSFER
        queryUserId: userId !== undefined && userId !== null && userId !== '' ? Number(userId) : undefined,
        pageNumber: this.listPagin.page,
        pageSize: this.listPagin.limit,
      }).then(res => {
        const payload = res && (res.data !== undefined ? res.data : res)
        const rows = (payload && payload.rows) || []
        this.tableData = rows
        this.listPagin.total = (payload && payload.total) || 0
      }).catch(err => {
        console.warn('软件列表加载失败', err)
        this.tableData = []
      }).finally(() => {
        this.loading = false
      })
    },
    toggleType(index) {
      if (this.type.active === index) return
      this.type.active = index
      // 切换到定制软件厅时，重置二级切换为「个人定制」
      if (index === 2) this.crowdMode = 'personal'
      this.listPagin.page = 1
      this.getList() // 切换分类自动重新请求接口
    },
    // 定制软件厅下的二级切换（个人定制 / 众筹）
    changeCrowdMode(mode) {
      if (this.crowdMode === mode) return
      this.crowdMode = mode
      this.listPagin.page = 1
      this.getList()
    },
    changePage(e) {
      this.listPagin.page = e
      this.getList()
    },
    changePageSize(size) {
      this.listPagin.limit = size
      this.listPagin.page = 1
      this.getList()
    },

    // ============ 来源配色 ============
    getSoftwareSources() {
      softwareSourceList().then(res => {
        const list = this.normalizeSource(res)
        const palette = [
          { bg: '#e6f7ff', fg: '#096dd9', bd: '#91d5ff' },
          { bg: '#f6ffed', fg: '#389e0d', bd: '#b7eb8f' },
          { bg: '#fff7e6', fg: '#d46b08', bd: '#ffd591' },
          { bg: '#f9f0ff', fg: '#722ed1', bd: '#d3adf7' },
          { bg: '#fff1f0', fg: '#cf1322', bd: '#ffa39e' },
          { bg: '#e6fffb', fg: '#08979c', bd: '#87e8de' },
        ]
        const map = {}
        list.forEach((item, i) => {
          const label = typeof item === 'string' ? item : (item.dictLabel || item.label || '')
          if (label) map[label] = palette[i % palette.length]
        })
        this.sourceColorMap = map
      }).catch(() => {})
    },
    normalizeSource(res) {
      const data = res && (res.data !== undefined ? res.data : res)
      if (Array.isArray(data)) return data
      if (data && Array.isArray(data.rows)) return data.rows
      return []
    },
    sourceStyle(label) {
      const c = this.sourceColorMap[label]
      if (c) return { backgroundColor: c.bg, color: c.fg, borderColor: c.bd }
      return { backgroundColor: '#f5f5f5', color: '#666', borderColor: '#d9d9d9' }
    },
    // 众筹定制模式：personal-个人定制 / crowdfunding-多人众筹
    modeText(mode) {
      if (mode === 'crowdfunding') return '多人众筹'
      if (mode === 'personal') return '个人定制'
      return mode || '-'
    },
    // 判断交易师是否有「众筹标识」：后端可能在交易师详情接口返回该字段。
    // 兼容多个常见字段名；为真（1 / true / '1'）时显示「众筹」tab。
    // 若后端真实字段名不在下列之中，请告知，补充即可。
    // 是否有众筹标识：交易师详情接口返回 hasCustomDemand === 1 时显示「众筹」tab
    checkCrowdFlag(data) {
      if (!data || typeof data !== 'object') return false
      const v = data.hasCustomDemand
      return v === 1 || v === '1' || v === true
    },
    // 身份标签配色
    identityStyle(i) {
      const palette = [
        { bg: '#e6f7ff', fg: '#096dd9', bd: '#91d5ff' },
        { bg: '#f6ffed', fg: '#389e0d', bd: '#b7eb8f' },
        { bg: '#fff7e6', fg: '#d46b08', bd: '#ffd591' },
        { bg: '#f9f0ff', fg: '#722ed1', bd: '#d3adf7' },
        { bg: '#fff1f0', fg: '#cf1322', bd: '#ffa39e' },
        { bg: '#e6fffb', fg: '#08979c', bd: '#87e8de' },
      ]
      const c = palette[i % palette.length]
      return { backgroundColor: c.bg, color: c.fg, borderColor: c.bd }
    },

    // ============ 点击行为 ============
    // 点击「请平台技术再杀毒」：发起再杀毒（接口待定，先占位）
    killVirusAgain(row) {
      console.log('killVirusAgain', row)
      this.$message.info('申请平台再杀毒：' + (row.coin || '') + '缩币（接口待接入）')
    },
    // 有偿转让厅：打开购买弹窗
    openBuy(row) {
      this.buyRow = row
      this.buyPayType = 'balancepay'
      this.buyVisible = true
    },
    // 确认下单：调用创建订购订单接口（真实)
    confirmBuy() {
      if (!this.buyRow) return
      const id = this.buyRow.id
      if (id === undefined || id === null || id === '') {
        this.$message.warning('未获取到软件ID，无法下单')
        return
      }
      this.buyLoading = true
      softwarePaidTransferOrder({ softwareId: Number(id), payType: this.buyPayType })
        .then(res => {
          if (res && res.code === 200) {
            const data = res.data || {}
            if (data.payUrl) {
              window.open(data.payUrl, '_blank')
            }
            this.$message.success('下单成功')
            this.buyVisible = false
          } else {
            this.$message.error((res && res.msg) || '下单失败')
          }
        })
        .catch(err => {
          this.$message.error((err && err.msg) ? err.msg : '下单失败，请稍后重试')
        })
        .finally(() => {
          this.buyLoading = false
        })
    },

    // ============ 定制软件需求：详情 / 投标 / 众筹 ============
    // 附件字段 demandFile 可能是数组或逗号分隔字符串，统一规范为数组
    formatFiles(val) {
      if (!val) return []
      if (Array.isArray(val)) return val.filter(Boolean)
      if (typeof val === 'string') {
        return val.split(',').map(s => s.trim()).filter(Boolean)
      }
      return []
    },
    // 打开详情弹窗
    openDetail(row) {
      this.detailRow = row
      this.detailMode = row.mode === 'crowdfunding' ? 'crowdfunding' : 'personal'
      this.detailVisible = true
    },
    // 打开投标 / 众筹填写弹窗（暂不调接口，仅收集信息）
    openBid(row) {
      this.bidRow = row
      this.bidMode = row.mode === 'crowdfunding' ? 'crowdfunding' : 'personal'
      this.bidForm = { amount: '', duration: '', team: '', phone: '', solution: '', selfRecommendation: '', remark: '', contactPhone: '' }
      this.bidVisible = true
    },
    // 提交投标 / 众筹
    submitBid() {
      const amount = Number(this.bidForm.amount)
      if (this.bidForm.amount === '' || this.bidForm.amount === null || isNaN(amount) || amount <= 0) {
        this.$message.warning('请输入正确的金额（大于 0）')
        return
      }
      const customId = this.bidRow && (this.bidRow.id || this.bidRow.customId)
      if (customId === undefined || customId === null || customId === '') {
        this.$message.warning('未获取到需求ID')
        return
      }
      // 众筹：调出资认购接口
      if (this.bidMode === 'crowdfunding') {
        const teamName = (this.bidForm.team || '').trim()
        const contactPhone = (this.bidForm.phone || '').trim()
        if (!teamName) {
          this.$message.warning('请输入参与团队/个人名称')
          return
        }
        if (!contactPhone) {
          this.$message.warning('请输入联系电话')
          return
        }
        if (teamName.length > 100) {
          this.$message.warning('参与团队/个人名称不能超过 100 字符')
          return
        }
        if (contactPhone.length > 20) {
          this.$message.warning('联系电话不能超过 20 字符')
          return
        }
        this.bidLoading = true
        softwareCustomCrowdJoin({
          amount: amount,
          contactPhone: contactPhone,
          customId: Number(customId),
          remark: (this.bidForm.remark || '').trim(),
          teamName: teamName,
        })
          .then(res => {
            if (res && res.code === 200) {
              this.bidVisible = false
              this.$message.success('众筹认购提交成功')
              // 刷新众筹列表，回显最新参与情况
              this.getList()
            } else {
              this.$message.error((res && res.msg) || '众筹认购提交失败')
            }
          })
          .catch(err => {
            console.warn('众筹认购提交失败', err)
            this.$message.error('众筹认购提交失败')
          })
          .finally(() => {
            this.bidLoading = false
          })
        return
      }
      // 个人定制投标：调 /stage-api/software/custom/bid/submit
      const duration = Number(this.bidForm.duration)
      if (this.bidForm.duration === '' || this.bidForm.duration === null || isNaN(duration) || duration <= 0) {
        this.$message.warning('请输入正确的预计开发周期（大于 0 天）')
        return
      }
      const solution = (this.bidForm.solution || '').trim()
      if (!solution) {
        this.$message.warning('请输入解决方案说明')
        return
      }
      const teamName = (this.bidForm.team || '').trim()
      if (!teamName) {
        this.$message.warning('请输入投标团队')
        return
      }
      const selfRecommendation = (this.bidForm.selfRecommendation || '').trim()
      const contactPhone = (this.bidForm.contactPhone || '').trim()
      if (!contactPhone) {
        this.$message.warning('请输入手机号')
        return
      }
      this.bidLoading = true
      softwareCustomBidSubmit({
        customId: Number(customId),
        price: amount,
        duration: duration,
        solution: solution,
        teamName: teamName,
        selfRecommendation: selfRecommendation,
        contactPhone: contactPhone,
      })
        .then(res => {
          if (res && res.code === 200) {
            this.bidVisible = false
            this.$message.success('投标提交成功')
            // 刷新个人定制列表
            this.getList()
          } else {
            this.$message.error((res && res.msg) || '投标提交失败')
          }
        })
        .catch(err => {
          console.warn('投标提交失败', err)
          this.$message.error('投标提交失败')
        })
        .finally(() => {
          this.bidLoading = false
        })
    },
    // 撤标（已投标状态：myBidStatus === 0）
    withdrawBid(row) {
      const customId = row && (row.id || row.customId)
      if (customId === undefined || customId === null || customId === '') {
        this.$message.warning('未获取到需求ID')
        return
      }
      this.$confirm('确定撤回该投标吗？', '撤标确认', {
        type: 'warning',
      }).then(() => {
        softwareCustomBidWithdraw({ customId: Number(customId) })
          .then(res => {
            if (res && res.code === 200) {
              this.$message.success('撤标成功')
              // 刷新列表，回显最新投标状态
              this.getList()
            } else {
              this.$message.error((res && res.msg) || '撤标失败')
            }
          })
          .catch(err => {
            console.warn('撤标失败', err)
            this.$message.error('撤标失败')
          })
      }).catch(() => {})
    },
    // 取众筹参与人列表（兼容 crowdList / participants 字段；后端真实字段名若不同，改此处即可）
    crowdListOf(row) {
      if (!row) return []
      const list = row.crowdList || row.participants || []
      return Array.isArray(list) ? list : []
    },

    // ============ 众筹留言板块 ============
    // 打开留言弹窗，加载沟通记录
    openMessage(row) {
      this.msgRow = row
      this.msgContent = ''
      this.msgList = []
      this.msgVisible = true
      this.loadMessages(row)
    },
    loadMessages(row) {
      const customId = row.id || row.customId
      if (customId === undefined || customId === null || customId === '') {
        this.$message.warning('未获取到需求ID，无法加载沟通记录')
        return
      }
      this.msgLoading = true
      softwareCustomMessageList({ customId: Number(customId) })
        .then(res => {
          const payload = res && (res.data !== undefined ? res.data : res)
          const rows = (payload && payload.rows) || (Array.isArray(payload) ? payload : [])
          const myId = (this.vuex_userInfo && this.vuex_userInfo.userId) || null
          this.msgList = rows.map(x => ({
            ...x,
            mine: myId != null && x.userId != null && Number(x.userId) === Number(myId),
          }))
        })
        .catch(err => {
          console.warn('沟通记录加载失败', err)
          this.msgList = []
        })
        .finally(() => {
          this.msgLoading = false
        })
    },
    sendMessage() {
      const content = (this.msgContent || '').trim()
      if (!content) {
        this.$message.warning('请输入沟通内容')
        return
      }
      const customId = this.msgRow && (this.msgRow.id || this.msgRow.customId)
      if (customId === undefined || customId === null || customId === '') {
        this.$message.warning('未获取到需求ID，无法发送')
        return
      }
      this.msgSending = true
      softwareCustomMessageSend({ content, customId: Number(customId) })
        .then(res => {
          if (res && res.code === 200) {
            this.msgContent = ''
            this.$message.success('发送成功')
            this.loadMessages(this.msgRow)
          } else {
            this.$message.error((res && res.msg) || '发送失败')
          }
        })
        .catch(err => {
          this.$message.error((err && err.msg) ? err.msg : '发送失败，请稍后重试')
        })
        .finally(() => {
          this.msgSending = false
        })
    },
    // 判断众筹行是否为当前登录用户自己发布的（是自己则不显示「众筹」按钮）
    // 兼容后端多种归属字段名：userId / createUserId / publishUserId / dealerId
    isOwnRow(row) {
      if (!row) return false
      const myId = (this.vuex_userInfo && this.vuex_userInfo.userId) || null
      if (myId == null) return false
      const ownerId = row.userId != null ? row.userId
        : (row.createUserId != null ? row.createUserId
          : (row.publishUserId != null ? row.publishUserId
            : (row.dealerId != null ? row.dealerId : null)))
      if (ownerId == null) return false
      return Number(ownerId) === Number(myId)
    },
    // 沟通记录显示发送人姓名（用户名优先 senderName；无名字时显示 userId:xxxx）
    messageName(item) {
      if (!item) return '未知用户'
      const name = item.senderName || item.userName || item.nickName || item.name || item.createBy || item.fromUserName || ''
      if (name) return name
      const uid = item.userId || item.fromUserId || item.senderId || ''
      return uid ? 'userId:' + uid : '未知用户'
    },

    // ============ 下载软件文件（softPath 需补全前缀） ============
    // 从路径/URL 中提取纯文件名（用于按钮展示）
    fileName(p) {
      if (!p) return ''
      const clean = String(p).split('?')[0]
      return clean.substring(clean.lastIndexOf('/') + 1)
    },
    // 补全前缀：base = VUE_APP_BASE_API；接口/文件路径自带 /stage-api
    fullUrl(p) {
      if (!p) return ''
      if (/^https?:\/\//i.test(p)) return p
      const base = process.env.VUE_APP_BASE_API || ''
      const sep = base.endsWith('/') ? '' : '/'
      return base + sep + 'stage-api' + (p.startsWith('/') ? p : '/' + p)
    },
    // 下载：走 $http 带 Authorization 防 401；响应拦截器对 blob 直接透传
    downloadFile(path) {
      if (!path) return
      const url = path.startsWith('/') ? '/stage-api' + path : '/stage-api/' + path
      this.$http.get(url, { responseType: 'blob' }).then(blob => {
        if (!(blob instanceof Blob) || (blob.type && blob.type.indexOf('json') > -1)) {
          this.$message && this.$message.error((blob && blob.msg) || '下载失败，请确认已登录')
          return
        }
        this.$utils.downloadFile(blob, this.fileName(path), blob.type || 'application/octet-stream')
      }).catch(e => {
        this.$message && this.$message.error('下载失败：' + ((e && e.msg) || '网络异常'))
      })
    },
    // 彩种标签配色：已知类型固定配色，未知类型按名称哈希稳定取色，保证不同彩种样式各异
    preTypeStyle(name) {
      const map = {
        '双色球': { bg: '#FDE2E1', color: '#F56C6C' },
        '大乐透': { bg: '#E1F3D8', color: '#67C23A' },
        '福彩3D': { bg: '#E6F0FF', color: '#409EFF' },
        '排列3': { bg: '#F3E8FF', color: '#9C27B0' },
        '排列5': { bg: '#E0F7FA', color: '#13C2C2' },
        '七乐彩': { bg: '#FFF3E0', color: '#FA8C16' },
        '快乐8': { bg: '#FFF0F6', color: '#EB2F96' },
      }
      if (name && map[name]) return { backgroundColor: map[name].bg, color: map[name].color }
      const palette = [
        { bg: '#FDE2E1', color: '#F56C6C' },
        { bg: '#E1F3D8', color: '#67C23A' },
        { bg: '#E6F0FF', color: '#409EFF' },
        { bg: '#F3E8FF', color: '#9C27B0' },
        { bg: '#FFF3E0', color: '#FA8C16' },
        { bg: '#E0F7FA', color: '#13C2C2' },
        { bg: '#FFF0F6', color: '#EB2F96' },
        { bg: '#E8EAF6', color: '#3F51B5' },
      ]
      const key = String(name || '')
      let h = 0
      for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0
      const c = palette[h % palette.length]
      return { backgroundColor: c.bg, color: c.color }
    },
  }
};
</script>

<style lang="scss" scoped>
.dealer-header {
  margin: 16px 0;
  display: flex;
  align-items: center;

  .dealer-title {
    color: #347caf;
    font-weight: bold;
    font-size: 20px;
  }
}

.section {
  margin: 18px 0;

  .section-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    border-left: 4px solid #347caf;
    padding-left: 10px;
    margin-bottom: 14px;
  }
}

// 板块一：个人信息
.info-card {
  display: flex;
  align-items: center;
  padding: 20px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;

  .info-avatar {
    flex: 0 0 auto;
    background: #347caf;
    font-size: xxx-large;
  }

  .info-main {
    margin-left: 22px;
    flex: 1;

    .info-name {
      font-size: 18px;
      font-weight: bold;
      color: #222;

      .info-level {
        margin-left: 10px;
        font-size: 12px;
        color: #d46b08;
        background: #fff7e6;
        border: 1px solid #ffd591;
        border-radius: 10px;
        padding: 1px 8px;
      }
    }

    .info-sub {
      margin: 4px 0 10px;
      color: #999;
      font-size: 13px;
    }

    .info-intro {
      margin: 10px 0;
      color: #666;
      line-height: 1.6;
    }

    .info-meta {
      display: flex;
      flex-wrap: wrap;
      gap: 22px;
      color: #888;
      font-size: 13px;

      .info-num {
        font-weight: bold;
        font-size: 14px;
      }
    }
  }
}

// 板块二：身份标签
.identity-card {
  padding: 18px 20px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;

  .identity-tag {
    display: inline-block;
    padding: 6px 16px;
    border-radius: 16px;
    border: 1px solid #d9d9d9;
    font-size: 13px;
  }

  .empty-tip {
    color: #999;
  }
}

// 板块三：发布软件
.type {
  display: flex;
  align-items: center;
  margin: 8px 0 14px;
  border-bottom: 2px solid #eee;

  span {
    display: inline-block;
    padding: 12px 28px;
    cursor: pointer;
    font-size: 15px;
    color: #555;

    &.active {
      color: #347caf;
      font-weight: bold;
      border-bottom: 2px solid #347caf;
      margin-bottom: -2px;
    }
  }
}

// 众筹 tab 内的二级筛选（定制模式）
.crowd-filter {
  display: flex;
  align-items: center;
  margin: -4px 0 14px;

  .crowd-filter-label {
    font-size: 13px;
    color: #888;
    margin-right: 6px;
  }

  .crowd-filter-item {
    display: inline-block;
    padding: 4px 16px;
    margin-right: 10px;
    cursor: pointer;
    font-size: 13px;
    color: #555;
    border: 1px solid #d9d9d9;
    border-radius: 14px;
    background: #fff;

    &:hover {
      color: #347caf;
      border-color: #347caf;
    }

    &.active {
      color: #fff;
      font-weight: bold;
      background: #347caf;
      border-color: #347caf;
    }
  }
}

.table {
  .type-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.5;
    white-space: nowrap;
  }

  .pagination {
    margin: 30px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

// 发布者是否杀毒：是/否 不同样式
.tag-yes {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 4px;
  background: #f6ffed;
  color: #389e0d;
  border: 1px solid #b7eb8f;
}

.tag-no {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 4px;
  background: #fff1f0;
  color: #cf1322;
  border: 1px solid #ffa39e;
}

// 软件来源：按类型不同配色
.src-tag {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  font-size: 12px;
}

// 请平台技术再杀毒：数字加粗加重、可点击
.kill-virus-btn {
  cursor: pointer;
  color: #d46b08;

  .kill-coin {
    font-weight: bold;
    color: #cf1322;
    font-size: 15px;
    margin: 0 2px;
  }
}

// 转让状态文字
.tf-status-text {
  font-size: 12px;
  color: #888;
}

// 发布时间：文字缩小
.time-sm {
  font-size: 12px;
  color: #606266;
}

// 购买弹窗
.buy-box {
  .buy-name {
    margin-bottom: 16px;
    font-weight: bold;
  }

  .buy-row {
    display: flex;
    align-items: center;

    .buy-label {
      width: 80px;
      color: #666;
    }
  }
}

// 附件列：可点击下载链接
.file-link {
  display: inline-block;
  margin: 0 6px 2px 0;
  color: #409EFF;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #66b1ff;
  }
}

.file-empty {
  color: #bbb;
}

// 众筹人数高亮
.crowd-num {
  font-weight: bold;
  color: #E6A23C;
}

// 详情弹窗
.detail-box {
  .detail-sub-title {
    margin: 18px 0 10px;
    font-size: 14px;
    font-weight: bold;
    color: #333;
    border-left: 3px solid #347caf;
    padding-left: 8px;
  }

  .detail-empty {
    padding: 14px 0;
    text-align: center;
    color: #999;
    font-size: 13px;
  }
}

// 留言板块
.msg-box {
  .msg-row {
    margin-bottom: 12px;
    font-size: 13px;
    color: #666;
  }

  .msg-demand {
    margin-bottom: 10px;

    .file-line {
      line-height: 1.8;
    }
  }

  .msg-toolbar {
    margin-bottom: 8px;
    text-align: right;
  }

  .msg-list {
    max-height: 320px;
    overflow-y: auto;
    padding: 4px 2px;
    border: 1px solid #eee;
    border-radius: 6px;
    background: #fafafa;
  }

  .msg-empty {
    padding: 30px 0;
    text-align: center;
    color: #bbb;
    font-size: 13px;
  }

  .msg-item {
    margin: 8px 0;
    padding: 8px 12px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 6px;

    .msg-item-head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 4px;

      .msg-item-name {
        font-size: 13px;
        font-weight: bold;
        color: #347caf;
      }

      .msg-item-time {
        font-size: 12px;
        color: #aaa;
      }
    }

    .msg-item-content {
      font-size: 13px;
      color: #333;
      line-height: 1.6;
      white-space: pre-wrap;
      word-break: break-all;
    }
  }

  // 自己发的消息：右侧高亮
  .msg-item-mine {
    background: #ecf5ff;
    border-color: #b3d8ff;

    .msg-item-name {
      color: #409EFF;
    }
  }

  .msg-input {
    margin-top: 12px;
    display: flex;
    align-items: flex-end;

    .el-textarea {
      flex: 1;
      margin-right: 10px;
    }
  }
}
</style>
